import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { playbooksListRequestTypesResource } from '@jira/router-resources__playbooks-list-screen/src/playbooksListRequestTypesResource.tsx';
import playbookTemplatesEntryPoint from '@jira/spa-apps__project-settings-playbooks-template-view/src/playbookTemplatesEntryPoint.entrypoint.tsx';
import playbooksHorizontalNavEntrypoint from '@jira/spa-apps__project-settings-playbooks-horizontal-nav/src/playbooksHorizontalNavEntrypoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskPlaybooksTemplatesRoute } from '@jira/router-routes__project-settings-playbooks-routes/src/servicedeskPlaybooksTemplatesRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { PlaybookTemplatesLoadingView } from '@jira/playbooks__list-screen/src/PlaybookTemplatesLoadingView.tsx';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import type { Route } from '@atlassian/react-resource-router';

const templatesEntryPoint = createPageEntryPoint({
	main: playbookTemplatesEntryPoint,
	horizontalNavigation: playbooksHorizontalNavEntrypoint,
});

export const servicedeskPlaybooksTemplatesRouteEntry: Route = createEntry(
	servicedeskPlaybooksTemplatesRoute,
	() => ({
		group: 'project-settings-servicedesk',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		entryPoint() {
			if (
				fg('aem_rr_playbooks')
					? !isFeatureEnabled('jira-service-management', 'jsm-automation-playbook')
					: isFedRamp()
			) {
				return notFoundPageEntrypoint;
			}
			return templatesEntryPoint;
		},
		resources: [
			...getServiceDeskSettingsResources(),
			getConsolidationStateResource(),
			playbooksListRequestTypesResource,
		],
		meta: {
			reporting: {
				id: 'project-settings.playbooks.templates-view',
				packageName: camelCase('project-settings-playbooks-templates'),
				teamName: 'ITOps Phantom',
			},
		},

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		ufoName: 'playbook-templates',
		skeleton: PlaybookTemplatesLoadingView,
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
